import * as React from 'react'
import { ScrollView, Animated, Dimensions, Platform } from 'react-native'
import { View, Text } from '../../components/Themed'
import { useEffect, useState } from 'react'
import { RootTabScreenProps } from '../../navigation/types'
import RetrieveData from '../../firebase/fbDataRetrieval/RetrieveData'
import TapToLogout from '../../components/Kiosk/TapToLogout'
import KioskStartScreen from './Components/KioskStartScreen'
import { OrgLogoHeader } from '../../components/Headers/OrgLogoHeader'
import { BrandList } from './Components/BrandList'
import { Categories } from './Components/Categories'
import NavFooter from '../../components/Footers/NavFooter'
import { WebHeader } from '../../components/Headers/WebHeader'
import CopyrightFooter from '../../components/Footers/CopyrightFooter'
import { LoyaltyHeader } from './Components/LoyaltyHeader'
import POSNavBar from '../../navigation/POSNavBar'
import { PickupPointModal } from '../../components/PickupPoint'
import {
	mobileWebDeliveryToggle,
	SCREEN_MAX_WIDTH,
	smallTextSize,
	UNDER_MIN_HEIGHT,
} from '../../constants/GlobalStyle'
import CuisineSelector from './Components/CuisineSelector'
import OrderBanner from '../../components/Delivery/OrderBanner'
import { useAppDispatch, useAppSelector } from '../../state/hooks'
import { setDataState } from '../../state/Slices/dataSlice'
import DeliveryPickupToggle from '../../components/Delivery/DeliveryPickupToggle'
import ClubKitchenFooter from '../../components/Footers/ClubKitchenFooter'
import { Box, Inline, Stack } from '../../components/DesignSystem'
import ImageObject from '../../components/Image/ImageObject'
import { useBreakpoints } from '../../components/DesignSystem'
export default function RestaurantSelectScreen({ navigation }: RootTabScreenProps<any>) {
	const { loadedData, organizationLogo, dataIsDoneLoading, showKioskStartScreen } = useAppSelector(
		state => state.data
	)
	const { appDisplayOptions, pickupPointsEnabled } = useAppSelector(state => state.settings)
	const {
		homeLayout,
		showRestaurants,
		showCategories,
		showBrands,
		showLoyalty,
		showCuisines,
		banner,
		showDisclaimerText,
	} = appDisplayOptions
	const { selectedPickupPoint } = useAppSelector(state => state.persisted)
	const setShowKioskStartScreen = value => {
		dispatch(setDataState({ showKioskStartScreen: value }))
	}

	const restaurantListPaddingHorizontal = Dimensions.get('window').width * 0.04
	const HEADER_MAX_WIDTH = restaurantListPaddingHorizontal * 2

	const { isMobile } = useBreakpoints()

	const [pickupPointModalVisible, setPickupPointModalVisible] = useState(
		selectedPickupPoint === null
	)
	const dispatch = useAppDispatch()

	useEffect(() => {
		if (showKioskStartScreen && global.kiosk) {
			dispatch(setDataState({ disableIdleTimer: true }))
		} else {
			dispatch(setDataState({ disableIdleTimer: false }))
		}
	}, [showKioskStartScreen])

	useEffect(() => {
		if (dataIsDoneLoading && loadedData[global.org].singleBrandEnabled && global.kiosk) {
			navigation.navigate('HomeStack', {
				screen: 'Menu',
				params: { rId: loadedData['defaultRestaurant'].id },
			})
		}

		dispatch(setDataState({ navContext: navigation }))
	}, [dataIsDoneLoading])

	function renderPage() {
		if (loadedData[global.org].singleBrandEnabled) {
			navigation.navigate('HomeStack', {
				screen: 'Menu',
				params: { rId: loadedData['defaultRestaurant'].id },
			})

			return <></>
		}
		return (
			<>
				{Platform.OS === 'web' && !UNDER_MIN_HEIGHT && (
					<WebHeader logo={organizationLogo} navigation={navigation} />
				)}
				{pickupPointsEnabled && !global.kiosk && (
					<PickupPointModal
						visible={pickupPointModalVisible}
						setVisible={setPickupPointModalVisible}
					/>
				)}
				<OrderBanner navigation={navigation} />
				<ScrollView
					contentContainerStyle={[
						{ justifyContent: 'space-between' },
						Platform.OS === 'web' && { flexGrow: 1 },
					]}
				>
					{Platform.OS === 'web' && UNDER_MIN_HEIGHT && (
						<WebHeader logo={organizationLogo} navigation={navigation} />
					)}
					{Platform.OS !== 'web' && (
						<OrgLogoHeader
							logo={organizationLogo}
							padding={showRestaurants ? smallTextSize * 2 : 50}
						/>
					)}

					{Platform.OS === 'web' && mobileWebDeliveryToggle && (
						<View>
							<DeliveryPickupToggle textColor={global.orgColor2} homePage={true} useHeaderStyle />
							{isMobile && banner?.mobile && (
								<ImageObject
									source={banner?.mobile}
									style={{
										width: '100%',
										resizeMode: 'cover',
									}}
									resizeMode="cover"
								/>
							)}
						</View>
					)}

					{Platform.OS === 'web' && !isMobile && banner?.desktop && (
						<View
							style={{
								width: '100%',
								display: 'flex',
								flexDirection: 'row',
								justifyContent: 'center',
								backgroundColor: banner?.backgroundColor || global.orgColor,
								paddingHorizontal: restaurantListPaddingHorizontal,
							}}
						>
							<Box style={{ maxWidth: SCREEN_MAX_WIDTH - HEADER_MAX_WIDTH }}>
								<ImageObject
									source={banner?.desktop}
									style={{
										width: '100%',
										resizeMode: 'cover',
									}}
									resizeMode="cover"
								/>
							</Box>
						</View>
					)}

					{showRestaurants && <CuisineSelector navigation={navigation} />}
					{showLoyalty && loadedData[global.org].loyaltyEnabled && !global.kiosk && (
						<LoyaltyHeader navigation={navigation} />
					)}
					{showCategories && <Categories navigation={navigation} />}
					{showBrands && <BrandList navigation={navigation} />}

					<View
						style={{
							height:
								((showRestaurants && !(showBrands || showCategories)) ||
									global.org === 'clubkitchen') &&
								Platform.OS === 'web'
									? 0
									: Dimensions.get('window').height * 0.12,
						}}
					></View>

					{Platform.OS !== 'web' && showDisclaimerText && (
						<View
							style={{
								display: showCuisines ? 'flex' : 'none',
								marginBottom: 16,
							}}
						>
							<Text style={{ textAlign: 'center', opacity: 0.3, paddingTop: 10 }}>
								Icons by Freepik
							</Text>
						</View>
					)}

					{Platform.OS === 'web' && (!showRestaurants || showCategories || showBrands) && (
						<>
							{global.org === 'clubkitchen' && <ClubKitchenFooter />}
							<CopyrightFooter showIcons={showCuisines} />
						</>
					)}
				</ScrollView>
				{global.kiosk && !global.pos ? (
					<NavFooter navigation={navigation} checkoutBar={true} />
				) : null}
				{global.pos ? <POSNavBar navigation={navigation} screenName={'HomeStack'} /> : null}
			</>
		)
	}
	if (global.kiosk && global.org !== undefined && !dataIsDoneLoading) {
		const setDataIsDoneLoading = value => {
			dispatch(setDataState({ dataIsDoneLoading: value }))
		}
		return (
			<>
				<RetrieveData referralCode={''} loadingTracker={setDataIsDoneLoading}>
					<TapToLogout navigation={navigation} />
					{dataIsDoneLoading ? (
						<Animated.View style={{ flex: 1 }}>
							{showKioskStartScreen && !global.pos && global.kiosk ? (
								<KioskStartScreen
									defaultLogo={organizationLogo}
									imageList={loadedData.promoImages ? loadedData.promoImages : []}
									setVisible={setShowKioskStartScreen}
								/>
							) : (
								renderPage()
							)}
						</Animated.View>
					) : (
						<></>
					)}
				</RetrieveData>
			</>
		)
	} else {
		return (
			<>
				{global.kiosk ? (
					<>
						<TapToLogout navigation={navigation} />
						<Animated.View style={{ flex: 1 }}>
							{showKioskStartScreen && !global.pos && global.kiosk ? (
								<KioskStartScreen
									defaultLogo={organizationLogo}
									imageList={loadedData.promoImages ? loadedData.promoImages : []}
									setVisible={setShowKioskStartScreen}
								/>
							) : (
								renderPage()
							)}
						</Animated.View>
					</>
				) : (
					renderPage()
				)}
			</>
		)
	}
}
